import { render } from "./HighlightedText.vue?vue&type=template&id=190b12d9&scoped=true"
import script from "./HighlightedText.vue?vue&type=script&lang=js"
export * from "./HighlightedText.vue?vue&type=script&lang=js"

import "./HighlightedText.vue?vue&type=style&index=0&id=190b12d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190b12d9"]])

export default __exports__